import * as React from "react";
import i18n from "i18next";
import {toast} from "react-toastify";
import FeedbackMessage, {IError, IInfo, IWarning} from "../components/FeedbackMessage";

/**
 * Interface for error details
 */
interface ErrorDetails {
    response?:
    {
        status?: number,
        statusText?: string,
        data?: {
            message?: string;
            uuid?: string;
            status?: string;
        }
    };
}

/**
 * Interface for info details
 */
export interface InfoDetails {
    response?:
    {
        status?: number,
        statusText?: string,
        message?: string;
    };
}

export enum FeedbackTypeEnum {
    INFO = "info",
    ERROR = "error",
    WARNING = "warning",
}

export type FeedbackData = IInfo | IError | IWarning;

/**
 * Convert a time stamp to a JSX element to be displayed in the ErrorView.
 */
export const timestampToString = (timestamp: number): JSX.Element => {
    const ts = new Date(timestamp);
    return <div>{ts.toString()}</div>;
};
/**
 * Parse the human readable info message from a back end info.
 */
export const infoResponsetoString = (infoDetails: any): JSX.Element | null => {
    let result = null;
    if (infoDetails) {
        const ifDetails: InfoDetails = infoDetails;
        if (ifDetails.response
            && ifDetails.response.status
        ) {
            let statusText = !ifDetails.response.statusText ? null : ifDetails.response.statusText;
            const infoMessage = !ifDetails.response.message ? null :
                // translate
                <div>{i18n.t("INFO:INFO_MESSAGE") + ': ' + ifDetails.response.message}</div>;

            result = (
                <div>
                    <div>{i18n.t("INFO:INFO_CODE") + ': ' + ifDetails.response.status + ' - ' + statusText}</div>
                    {infoMessage}
                </div>
            );
        }
        else {
            result = <div>{ifDetails.toString()}</div>;
        }
    }
    return result;
};

/**
 * Parse the human readable error message from a back end error reason.
 */
export const errorResponsetoString = (errorDetails: any): JSX.Element | null => {
    let result = null;
    if (errorDetails) {
        const errDetails: ErrorDetails = errorDetails;
        if (errDetails.response
            && errDetails.response.status
        ) {
            let statusText = !errDetails.response.data || !errDetails.response.data.status ? null : errDetails.response.data.status;
            const errorMessage = !errDetails.response.data || !errDetails.response.data.message ? null :
                <div>{i18n.t("ERRORS:ERROR_MESSAGE") + ': ' + errDetails.response.data.message}</div>;
            const errorUuid = !errDetails.response.data || !errDetails.response.data.uuid ? null :
                <div>{'UUID: ' + ': ' + errDetails.response.data.uuid}</div>;

            if (errDetails.response.status === 400) {
                statusText = "Bad Request!";
            }
            result = (
                <div>
                    <div>{i18n.t("ERRORS:ERROR_CODE") + ': ' + errDetails.response.status + ' - ' + statusText}</div>
                    {errorMessage}
                    {errorUuid}
                </div>
            );
        }
        else {
            result = <div>{errDetails.toString()}</div>;
        }
    }
    return result;
};

export const renderErrorToast = (error: IError) => {
    toast.error(
        (
            <FeedbackMessage
                type={FeedbackTypeEnum.ERROR}
                data={error}
            />
        ),
        {
            toastId: error.message
        }
    );
};

export const renderInfoToast = (info: IInfo) => {
    toast.info(
        (
            <FeedbackMessage
                type={FeedbackTypeEnum.INFO}
                data={info}
            />
        ),
        {
            toastId: info.message
        }
    );
};

export const renderSuccessToast = (info: IInfo, autoClose?: number) => {
    toast.success(
        (
            <FeedbackMessage
                type={FeedbackTypeEnum.INFO}
                data={info}
            />
        ),
        {
            toastId: info.message,
            autoClose
        }
    );
};

export const renderWarningToast = (warning: IWarning) => {
    toast.warn(
        (
            <FeedbackMessage
                type={FeedbackTypeEnum.WARNING}
                data={warning}
            />
        ),
        {
            toastId: warning.message
        }
    );
};



// WEBPACK FOOTER //
// ./src/utils/FeedbackMessageUtils.tsx